import {
  CheckInSpecialBaggageItem,
} from '@dapi/sdk';

export const bike: CheckInSpecialBaggageItem = {
  type: 'BIKE',
  description: ''
};

export const wheelchair: CheckInSpecialBaggageItem = {
  type: 'WCH',
  description: ''
};

export const weapon: CheckInSpecialBaggageItem = {
  type: 'WEAP',
  description: ''
};

export const specialEquipment: CheckInSpecialBaggageItem = {
  type: 'SPEQ',
  description: ''
};

export const checkInHandLuggage: CheckInSpecialBaggageItem = {
  type: 'HAND',
  description: 'Hand luggage at C/I'
};

export const buggyGate: CheckInSpecialBaggageItem = {
  type: 'BGGT',
  description: 'Buggy Gate'
};
